import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'superflex-filtro-btn',
    template: `
        <p-button
            label="{{ 'BOTONES.filtrar' | translate }}"
            [icon]="icon"
            [type]="'submit'"
            [styleClass]="styleClass"
            [class]="class"
            (onClick)="onClick.emit()"
            [disabled]="isDisabled">
        </p-button>`,
})
export class FilterBtnComponent {

    @Input() isDisabled: boolean;
    @Output() onClick = new EventEmitter<any>();
    @Input() icon = '';
    @Input() styleClass = 'p-mr-2';
    @Input() class = '';

    constructor() {/***/}
}
